<template>
  <h1 class="choice-title" v-if="$store.getters?.getQuesInfo?.type === 1 && data?.isRequired" :class="{
    required: $store.getters?.getQuesInfo?.type === 1 && data?.isRequired,
  }">
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span>{{ data?.title }}
  </h1>
  <h1 class="choice-title" v-else :class="{ required: showAnswerRequired }">
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span>{{ data?.title }}
  </h1>
  <div class="choice">
    <div class="choice-item" :class="{ placeholder: !state.cascaderValue }" @click="state.show = true">
      {{ state.fieldValue }}
    </div>
  </div>
  <Popup v-model:show="state.show" round position="bottom">
    <Cascader v-model="state.cascaderValue" :title="data?.title" active-color="#1989fa" :options="cascaderOptions"
      :field-names="fieldNames" @close="state.show = false" @finish="onFinish">
      <template #title>
        <div>
          <div>{{ data?.title }}</div>
          <Search v-model="searchValue" placeholder="请输入搜索关键词" />
          <ul v-if="showResultList" class="result-list">
            <li class="result-item" @click="handleResultItemClick(item)" v-for="item in resultList">{{ item.label }}</li>
          </ul>
        </div>
      </template>
    </Cascader>
  </Popup>
</template>

<script>
import '../choice/css/choice.scss'
import { ref, reactive, onMounted, watch } from 'vue'
import { onBeforeRouteUpdate } from 'vue-router'
import { Cascader, Popup, Search } from 'vant'
import shandong from '/public/json/sd.json'
import dezhouList from '@/utils/dezhou.js'
import { getAnswer } from '@/utils/tools'
import newDezhou from '@/utils/newDezhou.js'

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    currentChecked: {
      type: String,
      default: '',
    },
    // 临时处理答题个人题型必填显示
    showAnswerRequired: {
      type: Number,
      default: 0,
    },
    isReview: {
      type: Boolean,
      default: false,
    },
    quesIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Cascader,
    Popup,
    Search,
  },
  emits: ['cascaderChange'],
  setup(props, ctx) {
    const state = reactive({
      show: false,
      fieldValue: props.data?.title || '请选择',
      cascaderValue: '',
    })
    const fieldNames = {
      text: 'label',
    }
    // 选项列表，children 代表子选项，支持多级嵌套

    const cascaderOptions = ref([])

    const formatData = () => {
      let options = []

      if (props.data?.optionVoList[0]) {
        if (props.data?.questionType === 100) {
          options = [...dezhouList]
        } else if (props.data?.questionType === 101) {
          options = JSON.parse(JSON.stringify(dezhouList))
          options.map((item) => {
            item.children.map((i) => {
              i.children.map((j) => {
                delete j.children
              })
            })
          })
        } else if (props.data?.questionType === 102) {
          options = JSON.parse(JSON.stringify(dezhouList))
          options.map((item) => {
            item.children.map((i) => {
              delete i.children
            })
          })
        } else if (props.data?.questionType === 103) {
          options = JSON.parse(JSON.stringify(newDezhou))
        } else if (props.data?.questionType === 104) {
          options = JSON.parse(JSON.stringify(shandong))
          fieldNames.children = 'c'
          fieldNames.value = 'v'
          fieldNames.text = 'l'
        } else {
          // const reg = new RegExp(',"children":[]', 'g')
          const content = props.data.optionVoList[0].content
            .split(',"children":[]')
            .join('')
          options = [...JSON.parse(content)]
        }
      }

      return options
    }

    // 辅助函数：递归筛选数据
    function filterData(data, label) {
      return data.filter((item) => {
        if (props.data?.questionType === 104) {
          if (item.l?.includes(label)) {
            return true
          }

          if (item.c && item.c.length > 0) {
            item.c = filterData(item.c, label)
            return item.c.length > 0
          }

          return false
        } else {
          if (item.label?.includes(label)) {
            return true
          }

          if (item.children && item.children.length > 0) {
            item.children = filterData(item.children, label)
            return item.children.length > 0
          }

          return false
        }
      })
    }

    // 辅助函数：展开数据
    function flattenData(data, path = []) {
      const flattenedData = [];

      data.forEach(node => {
        node.c && (node.children = node.c)
        node.v && (node.value = node.v)
        node.l && (node.label = node.l)

        const newPath = [...path, node.label]; // 记录当前路径

        if (node.children && node.children.length > 0) {
          const children = flattenData(node.children, newPath); // 递归展开子节点，并传递当前路径
          flattenedData.push(...children);
        } else {
          flattenedData.push({
            label: newPath.join('/'), // 组合路径信息
            value: node.value
          });
        }
      });

      return flattenedData;
    }

    // 搜索的关键词
    const searchValue = ref('')
    const resultList = ref([])

    // 是否展示搜索结果列表
    const showResultList = ref(false)

    const handleResultItemClick = (item) => {
      state.cascaderValue = item.value
      showResultList.value = false
      state.show = false
      state.fieldValue = item.label
      // searchValue.value = ''
     
      ctx.emit('cascaderChange', {
        value: item.label,
        type: 'input',
        optionKey: props.data.optionVoList[0].optionKey,
        questionKey: props.data.questionKey,
        questionType: props.data.questionType,
      })
    }

    watch(searchValue, (n) => {
      if (n === '') {
        cascaderOptions.value = formatData()
        state.cascaderValue = ''
        showResultList.value = false
        resultList.value = []
      } else {
        showResultList.value = true
        resultList.value = flattenData(filterData(formatData(), n))
      }
    })

    // 全部选项选择完毕后，会触发 finish 事件
    const onFinish = ({ selectedOptions }) => {
      state.show = false
      state.fieldValue = selectedOptions
        .map((option) => option.label || option.l)
        .join('/')

      ctx.emit('cascaderChange', {
        value: state.fieldValue,
        type: 'input',
        optionKey: props.data.optionVoList[0].optionKey,
        questionKey: props.data.questionKey,
        questionType: props.data.questionType,
      })
    }

    onMounted(() => {
      if (!props.currentChecked) {
        state.fieldValue = '请选择'
      } else {
        state.fieldValue = props.currentChecked
      }

      cascaderOptions.value = formatData()

      const localAnswer = getAnswer(props.data.questionKey)

      if (localAnswer) {
        state.fieldValue = localAnswer?.[0].answerContent
      }
    })

    onBeforeRouteUpdate(() => {
      if (!props.currentChecked) {
        state.fieldValue = '请选择'
      } else {
        state.fieldValue = props.currentChecked
      }
    })

    return {
      searchValue,
      state,
      resultList,
      showResultList,
      cascaderOptions,
      fieldNames,
      handleResultItemClick,
      onFinish,
    }
  },
}
</script>

<style lang="scss" scoped>
.placeholder {
  color: #757575;
}

::v-deep {
  .van-cascader__title {
    width: 100%;
  }

  .van-cascader__header {
    padding: 10px;
    height: auto;
  }
}

.result-list {
  position: absolute;
  top: 150px;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  font-size: 30px;
  background-color: #fff;
  overflow-y: auto;
  z-index: 2;

  .result-item {
    padding: 10px 0;
    line-height: 1.4;
  }
}
</style>
